import type { InclusionOption, OperatorOption } from "app/pages/sales-intelligence/types/commonMaps";
import type { IRange, IRelativeDateRange } from "app/pages/sales-intelligence/types/range";

import type { IAppsSDKsFilterItem } from "../../sdk/types/filter-values";

import type { AppOperatingSystem } from "./platform";

export const deviceOptionMap = {
    ipad: "iPad",
    iPhone: "iPhone",
    both: "both",
} as const;
export type DeviceOption = (typeof deviceOptionMap)[keyof typeof deviceOptionMap];

export const appsPriceTypeMap = {
    free: "free",
    paid: "paid",
} as const;
export type AppsPriceType = (typeof appsPriceTypeMap)[keyof typeof appsPriceTypeMap];

export const appsCategoryTypesMap = {
    all: "all",
    primary: "primary",
} as const;

/** @deprecated use `IRelativeDateRange` */
export type IAppsUpdateDateFilterDto = IRelativeDateRange;

export interface IAppsPriceFilterDto {
    readonly type: AppsPriceType;
    readonly priceRange?: Partial<IRange<number>>;
}

export interface IAppListedAddressFilterDto {
    readonly countries: readonly number[];
}

export interface IAppsRatingFilter {
    readonly score?: readonly number[];
    readonly numberOfRatings?: Partial<IRange<number>>;
}

export interface IAppsDownloadsAndEngagementFilter {
    readonly country?: number;
    readonly monthlyDownloads?: Partial<IRange<number>>;
    readonly monthlyActiveUsers?: Partial<IRange<number>>;
    readonly device?: DeviceOption;
}

export interface IAppsAdSellersFilterItem {
    readonly inclusion: InclusionOption;
    readonly operator: OperatorOption;
    readonly adsSellerDomainNames: readonly string[];
}

export interface IAppsPermissionsFilter {
    readonly operator: string;
    readonly permissions: readonly string[];
}

export interface IIabCategoriesFilterDto {
    readonly inclusion: InclusionOption;
    readonly values: readonly string[];
}

export interface IAppsAndroidIdentifierFilter {
    readonly packageNames: readonly string[];
}

export interface IAppsAndroidCategoryFilter {
    readonly values: readonly string[];
}

export interface IAppsIosDownloadsAndEngagementFilter extends IAppsDownloadsAndEngagementFilter {
    readonly device?: DeviceOption;
}

export interface IAppsIosIdentifierFilter {
    readonly trackIds: readonly string[];
    readonly bundleIds: readonly string[];
}

export interface IAppsIosCategoryFilter {
    readonly type: string;
    readonly values: readonly string[];
}

export interface IBaseAppsFiltersDto {
    readonly market: AppOperatingSystem;

    readonly price: IAppsPriceFilterDto;
    readonly searchText: string;
    readonly updateDate: IRelativeDateRange;
    readonly releaseDate: IRelativeDateRange;
    readonly sdks: readonly IAppsSDKsFilterItem[];
    readonly listedAddress: IAppListedAddressFilterDto;
    readonly rating: IAppsRatingFilter;
    readonly permissions: IAppsPermissionsFilter;
    readonly appBusinessModels: readonly string[];
    readonly adsSellers: readonly IAppsAdSellersFilterItem[];
    readonly iabCategories: IIabCategoriesFilterDto;
}
export interface IAppsAndroidFiltersDto extends IBaseAppsFiltersDto {
    readonly identifier: IAppsAndroidIdentifierFilter;
    readonly category: IAppsAndroidCategoryFilter;
    readonly downloadsAndEngagement: IAppsDownloadsAndEngagementFilter;
}

export interface IAppsIosFiltersDto extends IBaseAppsFiltersDto {
    readonly identifier: IAppsIosIdentifierFilter;
    readonly category: IAppsIosCategoryFilter;
    readonly downloadsAndEngagement: IAppsIosDownloadsAndEngagementFilter;
}

export type AppsSearchFiltersDto = IAppsAndroidFiltersDto & IAppsIosFiltersDto;
